module.exports = __webpack_public_path__ + "img/contract-green.5d7946eb.svg";